module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ZBREAK"
  }), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_vm._v("Distance in Preaching")]), _vm._v(" "), _c('p', {
    staticClass: "SUBTITLE"
  }, [_vm._v("Room to Speak, Space to Listen")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_vm._v("Michael Brothers")]), _vm._v(" "), _c('p', {
    staticClass: "COMPANY"
  }, [_vm._v("William B. Eerdmans Publishing Company"), _c('br'), _vm._v("Grand Rapids, Michigan / Cambridge, U.K.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-284ceba7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brothers_Distance_in_Preaching_text.vue
// module id = 57
// module chunks = 0